import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Parkings (enrobés & asphalte)", href: "/services/parkings" },
  { label: "Dalles carrossables", href: "/services/dalles-carrossables" },
  { label: "Terrasses", href: "/services/terrasses" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function ToituresTerrassesPage() {
  return (
    <ServicePageLayout
      tag="Cœur de métier"
      title="Toitures-terrasses"
      subtitle="Étanchéité professionnelle de toitures-terrasses pour bâtiments résidentiels, tertiaires et industriels en Île-de-France."
      heroImage="https://readdy.ai/api/search-image?query=professional%20waterproofing%20work%20on%20large%20flat%20commercial%20rooftop%2C%20workers%20applying%20bituminous%20membrane%20torch-applied%2C%20wide%20angle%20aerial%20view%20of%20industrial%20roofing%20project%2C%20dramatic%20sky%2C%20professional%20BTP%20photography%2C%20sharp%20details%2C%20impressive%20scale&width=1440&height=900&seq=ksbtp-tt-hero-001&orientation=landscape"
      heroAlt="Étanchéité toiture-terrasse KS BTP"
      intro="KS BTP intervient sur tous types de toitures-terrasses : accessibles, inaccessibles, techniques ou végétalisées. Nous maîtrisons l'ensemble des systèmes d'étanchéité — membranes bitumineuses, EPDM, étanchéité liquide — et adaptons chaque solution aux contraintes structurelles et climatiques de votre ouvrage. Chaque chantier bénéficie d'un diagnostic préalable rigoureux et d'une mise en œuvre conforme aux DTU en vigueur."
      techItems={[
        { icon: "ri-fire-line", label: "Membranes bitumineuses" },
        { icon: "ri-drop-line", label: "Étanchéité liquide" },
        { icon: "ri-leaf-line", label: "Toiture végétalisée" },
        { icon: "ri-shield-line", label: "EPDM & géomembranes" },
        { icon: "ri-tools-line", label: "Réfection complète" },
        { icon: "ri-search-eye-line", label: "Diagnostic & audit" },
      ]}
      steps={[
        {
          number: "01",
          title: "Diagnostic",
          description: "Inspection complète de la toiture existante, identification des désordres et évaluation de l'état du support.",
        },
        {
          number: "02",
          title: "Préconisation",
          description: "Choix du système d'étanchéité adapté à votre toiture, établissement du devis détaillé.",
        },
        {
          number: "03",
          title: "Mise en œuvre",
          description: "Pose des membranes par nos équipes qualifiées, dans le respect strict des DTU et des règles de l'art.",
        },
        {
          number: "04",
          title: "Réception",
          description: "Contrôle final d'étanchéité, remise des documents de garantie décennale et du dossier de fin de chantier.",
        },
      ]}
      advantages={[
        "Maîtrise de tous les systèmes d'étanchéité : bitume, EPDM, résine, étanchéité liquide",
        "Respect des DTU 43.1, 43.3 et des normes NF en vigueur",
        "Garantie décennale sur l'ensemble de nos travaux",
        "Intervention rapide en Île-de-France, délais maîtrisés",
        "Équipes formées et expérimentées, plus de 26 ans de savoir-faire",
        "Devis gratuit et détaillé sous 48h",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=close%20up%20of%20torch%20applied%20bituminous%20waterproofing%20membrane%20on%20flat%20roof%2C%20professional%20roofer%20working%2C%20flame%20torch%2C%20dark%20grey%20surface%2C%20construction%20site%2C%20sharp%20detail%20photography&width=600&height=440&seq=ksbtp-tt-gal-001&orientation=landscape",
          alt: "Pose membrane bitumineuse",
        },
        {
          src: "https://readdy.ai/api/search-image?query=aerial%20view%20of%20large%20commercial%20building%20flat%20roof%20with%20completed%20black%20waterproofing%20membrane%2C%20clean%20geometric%20lines%2C%20urban%20environment%2C%20professional%20roofing%20project%20finished&width=600&height=440&seq=ksbtp-tt-gal-002&orientation=landscape",
          alt: "Toiture-terrasse terminée vue aérienne",
        },
        {
          src: "https://readdy.ai/api/search-image?query=green%20rooftop%20garden%20with%20waterproofed%20base%20layer%20visible%20at%20edges%2C%20modern%20urban%20building%2C%20lush%20vegetation%2C%20professional%20landscaping%20on%20rooftop%2C%20Paris%20architecture&width=600&height=440&seq=ksbtp-tt-gal-003&orientation=landscape",
          alt: "Toiture végétalisée",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
